import { createContext, useContext } from 'react';

interface UserSession {
  sessionId: string;
  regionId: string;
  userId?: string;
  email: string;
  accountName: string;
  multipleAccounts: boolean;
  theme: string;
  culture: string;
  timeZone: string;
  // SC-1529: per-integration ACL context for client-side action-hiding (backend still enforces). No tenant
  // flag — access is defined by grants. restrictedMapIds lists every integration carrying any grant (visible
  // only to grantees/admins); integrationPermissions holds this user's own grants.
  isAdmin?: boolean;
  restrictedMapIds?: string[];
  integrationPermissions?: Record<string, number>; // mapId -> TeamRole int (1 Reader/2 Contributor/3 Administrator)
}

const GlobalStateContext = createContext<{
  userSession?: UserSession;
  version?: string;
}>({});

const useGlobalState = () => {
  const context = useContext(GlobalStateContext);
  return context;
};

export { GlobalStateContext, useGlobalState };
export type { UserSession };
